import Amplify, { API, graphqlOperation } from "aws-amplify";
import * as gql from './appsync-gql'

export default {

  async getReservationsByUsername (username, currentDate) {
    return await API.graphql(
      graphqlOperation(gql.getReservationsByUsername, { username, currentDate })
    ).catch(e => {
      console.error('getReservationsByUsername', e)
      return e
    })
  },
/*
  async updateIdVerified (input) {
    return await API.graphql(
        graphqlOperation(gql.updateIdVerified, { input })
      ).catch(e => {
        console.error('updateIdVerified', e)
        return e
      })
  },
*/  
  async verifyMembers (input, hostVerifying) {
    return await API.graphql(
        graphqlOperation(gql.verifyMembers, { input, hostVerifying })
      ).catch(e => {
        console.error('verifyMembers', e)
        return e
      })
  },
  async getMembers (reservationCode) {
    return await API.graphql(
        graphqlOperation(
          gql.getMembers, { reservationCode }
        )
      )
      .catch(e => {
        console.error('getMembers', e)
        return e
      })
  },
  async updateMember (input) {
    input.lastUpdateOn = (new Date).toISOString()

    return await API.graphql(graphqlOperation(gql.updateMember, { input }))
      .catch(e => {
        console.error('updateMember', e)
        return e
      })
  }
}